export const formatters = [{
    type: 'NumberFormat',
    column: 1,
    options: {
      fractionDigits: 0,
      decimalSymbol: ',',
      groupingSymbol: '.'
    }
}];
